import SkillViewer from './src/main';

/* istanbul ignore next */
SkillViewer.install = function(Vue) {
  Vue.component(SkillViewer.name, SkillViewer);
};

export default SkillViewer;
